import { LitElement, html, css } from '@polymer/lit-element'
import {anchorRoute, gotoRoute} from './../Router'
import Auth from './../Auth'
import {render} from 'lit-html'
import App from './../App'
import UserAPI from './../UserAPI'


customElements.define('va-provider', class Provider extends LitElement {
  constructor(){
    super()    
  }

  static get properties(){
    return {
         

      name: {
        type: String,
        required: true
      },
      description: {
        type: String    
      },
      price: {
        type: String    
      },
    
    
      user: {
        type: Object
      },
      
      image: {
        type: String,
       
      },
      experience: {
        type: String    
      },
      occupation: {
        type: String    
      },
     
    }
  }

  firstUpdated(){
    super.firstUpdated()
  }

  testHandler(){
    alert("test")
  }


  success(){
    //create sl-dialog
    const dialogEl= document.createElement('sl-dialog')
    //add a className
    dialogEl.className ='provider-dialog'
    //sl-dialog content
    const dialogContent = html`


    <style>
    
    
    .successful{
     margin:auto;
     width: 50%;
     text-align: center;
    }
    
    .tick{
      margin-bottom:10%;
    }
    
    
    
    </style>

<div class="successful"> 


    <img class="tick" src="/images/tick.svg" />


    <h1>Hi Nina!  
    Your quotation is successfully.
    Please check on hired workers for more info.</h1>

    <sl-button href="/"  type="primary" >RETURN TO HOMESCREEN</sl-button>

    </div>

    
    `

    render(dialogContent,dialogEl)

    //append to body
    document.body.append(dialogEl)

    //show dialog
    dialogEl.show()



    //on hide delete dialog
    dialogEl.addEventListener('sl-after-hide', ()=> dialogEl.remove())

  }



  //this is for the dialog box after requesting a quote

  requestQuote(){
    //create sl-dialog
    const dialogEl= document.createElement('sl-dialog')
    //add a className
    dialogEl.className ='provider-dialog'
    //sl-dialog content
    const dialogContent = html`

    <style>

      .wrapper{
        
        width: 85%
        margin: auto;

      }

      .form-wrapper{
        width:100%;
        display: flex;
        flex-direction: row;
      }

      .wrapper-1{
        width:45%;
        margin-right: 5%;
      
        
      }
      .wrapper-2{
        width:45%;
      
        
      }

      input[type="date" i] {
        align-items: center;
        display: inline-flex;
        font-family: 'Poppins';
        padding-inline-start: 1px;
        cursor: default;
        overflow: hidden;
        padding: 5px;
        border: none;
       
    }

    .titles{
      font-family: Poppins;
      font-size: 20px;
      font-weight: 500;
      line-height: 30px;
      letter-spacing: 0em;
      text-align: left;
      color: #3A3A3A;



    }


    .header{
      font-family: Poppins;
      font-size: 28px;
      font-weight: 500;
      line-height: 42px;
      letter-spacing: 0em;
      text-align: left;

    }

    
    
    

    
      

  
</style>

    <div class="wrapper">
    
      <h1 class="header">Request a quote for your next project</h1>
      
      <div class="form-wrapper">
    
        <div class="wrapper-1">
        <div class="input-group-signup" style="margin-bottom: 1.5em;">
          <sl-textarea class="titles" label="What is your problem?"name="description" rows="5" placeholder="Description"></sl-textarea>
        </div>
      
      
      
            <div class="calender">
              
                  <label class="titles"> When do you want it to be done?</label> <br>
                  <input 
                    type="date"
                    name="date"
                    id="date"
                    class="form-input"
                  />
              
              </div> <br>


              

          </div>

          <div class="wrapper-2">
          
          <sl-input class="titles" label="What is your Budget?" placeholder="Rs 00000"></sl-input> 


        

          </div>

          <sl-button class="request-quote" type="primary" @click=${this.success.bind(this)}>SEND QUOTE</sl-button>

      </div>
     </div>
       

      

    

    
    



    
    `

    render(dialogContent,dialogEl)

    //append to body
    document.body.append(dialogEl)

    //show dialog
    dialogEl.show()



    //on hide delete dialog
    dialogEl.addEventListener('sl-after-hide', ()=> dialogEl.remove())

  }



  learnMore(){
    //create sl-dialog
    const dialogEl= document.createElement('sl-dialog')
    //add a className
    dialogEl.className ='provider-dialog'
    //sl-dialog content
    const dialogContent = html`


    <style>


    .content{
      display: flex;
      flex-direction: row;
    }

    .cardstyle{
      width:403px;
      height:373px;
      background-color: #fff;
      box-shadow: 4px 4px 15px 3px rgba(0, 0, 0, 0.09);
      border-radius: 15px;
      
      
    }

    .card-img{
      width: 373px;
      height: 236px;
      margin: 15px 0px 0px 15px;
      border-radius: 10px;
      
    }

    


    .card-txt{
      width: 373px;
      margin:auto;
      margin-left: 15px;
     
     
      margin-top: 1%;
      display: flex;
      flex-direction: row;
     
      
    }

    .learnmore{
      cursor: pointer;
    }

    

 


    .overlay:hover{
    
      opacity: 85%;
      transition: opacity 0.4s;
      
    }

    .img-text{
      text-align: center;
      margin-top: 25%;
      color: #fff;
      
     
    }

    .sideone{
      
      width: 50%;
    }

    .sidetwo{
     
      width: 50%;
      text-align: right;
    }

    .name{
      font-size: 24px;
      font-weight: 500;
      line-height: 36px;
      letter-spacing: 0em;
      text-align: left;
      margin-top: 0;

    }

    .occupation{
      font-family: Poppins;
      font-size: 16px;
      font-weight: 500;
      line-height: 24px;
      letter-spacing: 0em;
      text-align: left;
      color: #FFA132;

    }

    .price{
      font-family: Poppins;
      font-size: 16px;
      font-weight: 500;
      line-height: 24px;
      letter-spacing: 0em;
    
      color: #A7A7A7;

    }

    #experience{
      font-family: Poppins;
      font-size: 16px;
      font-weight: 500;
      line-height: 24px;
      letter-spacing: 0em;
      margin-top:2.5%;
      color: #FFA132;
     
      
    
      
    }

    .info{
      background: red;
      margin-left: 2%;
      background: #FFFFFF;
      box-shadow: 4px 4px 15px 3px rgba(0, 0, 0, 0.09);
      border-radius: 15px;
      width: 65%;

    }

    .infotxt{
      margin-left: 4%;
    }

    .title{
      font-family: 'Poppins';
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 30px;
    margin-top: 4%;
    color: #525252;
    }


    p{
      font-family: 'Poppins';
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      color: #525252;
    }

    .descriptiontxt{

      width: 90%;
      margin-bottom: 2%;
    }

    .skills{
      display: flex;
      flex-direction: row;
      width:45%;
      position:absolute;
      top: 49%;
    }
    
    .column1{
      width:30%;
    }

    .column2{
      text-align: right;
      
    }


    .columntxt{
      font-family: 'Poppins';
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      text-align: right;

      color: #A7A7A7;


    }

    .request-quote{
      position: absolute;
      left:77%;
      top: 67%;
      
    }

    /*-----------RESPONSIVE-----------------*/
    @media all and (max-width: 1024px){       
        
      .request-quote{
        left: 75%;
        top:77%;
      }


      .card-img{
        width: 373px;
        height: 236px;
        margin: 15px 0px 0px 5px;
        border-radius: 10px;
        
      }

      .card-txt{
        width: 350px;
        margin-left: 5px;
        
      
       
        
      }
      
     
  
      
    }


    @media all and (max-width: 962px){       
      

      .descriptiontxt{
        font-size: 14px;
        line-height: 20px;
      }
    
      .request-quote{
        left: 75%;
        top:85%;
      }

      p{
        font-size: 14px;
      }


      .columntxt{
        font-size: 14px;

      }

      .infotxt{
        margin-left: 8%;
      }
      
    
    
    
    
    
    }


    @media all and (max-width: 896px){      
      
      
     
      .content {
        display: flex;
        flex-direction: column;
     
        
    }

    .cardstyle{
      margin: auto;
     
    }

    .info{
      margin: auto;
      width: 100%;
    }

    .skills{
      margin: auto;
      width: 50%
    }



    
    }
  
  
    



    
    
    
    </style>

    <div class="content">

    <div class="cardstyle">

      
    
    <img class="card-img" src="${App.apiBase}/images/${this.image}" alt="${this.name}"/>
    
   
    </a>
    

    <div class="card-txt">

    <div class="sideone">
        <h1 class="name">${this.name} </h1>
        <p class="occupation">${this.occupation}</p>
    </div>

    <div class="sidetwo"
        
        <p id="experience">${this.experience} years experience</p>
        <p class="price" >Rs${this.price}/day</p>
        
    </div>
        

    </div>






    </div>


      <div class="info">

        <div class="infotxt">

          <h1 class="title">Description</h1>
              <p class="descriptiontxt"> ${this.description}</p>

              <div class="skills">

              <div class="column1">

              <p class="experience">Experience Level</p>
                      <p class="phone">Phone Number</p>
                      <p class="email">Email</p>
                      <p class="address">Address</p>
              
              </div>

                <div class="column2">
                      <p class="columntxt">  ${this.experience} yrs</p>
                      <p class="columntxt"> ${this.user.phone}</p>
                      <p class="columntxt"> ${this.user.email}</p>
                      <p class="columntxt"> ${this.user.address}</p>

                  </div>
              </div>

        </div>
     
        <sl-button class="request-quote" type="primary" @click=${this.requestQuote.bind(this)}>REQUEST A QUOTE</sl-button>
      </div>

     
    
    </div>
    



    
    `

    render(dialogContent,dialogEl)

    //append to body
    document.body.append(dialogEl)

    //show dialog
    dialogEl.show()



    //on hide delete dialog
    dialogEl.addEventListener('sl-after-hide', ()=> dialogEl.remove())

  }
  
  render(){    
    return html`
    <style>
      .cardstyle{
        width:403px;
        height:373px;
        background-color: #fff;
        box-shadow: 4px 4px 15px 3px rgba(0, 0, 0, 0.09);
        border-radius: 15px;
        margin-left: 7%;
        
    
        
        

      }

      .card-img{
        width: 373px;
        height: 236px;
        margin: 15px 0px 0px 15px;
        border-radius: 10px;
        
      }

      


      .card-txt{
        width: 373px;
        margin:auto;
        margin-left: 15px;
        position:absolute;

        margin-top: 1%;
        display: flex;
        flex-direction: row;
       
        
      }

      .learnmore{
        cursor: pointer;
      }

      

      .overlay{
          position: absolute;
          background: #FFA132;
          width: 373px;
          height: 236px;
          margin: 15px 0px 0 15px;
          border-radius: 10px;
          top: 7.7%;
          align-items: center;
          opacity: 0;
          
          

      }


      .overlay:hover{
      
        opacity: 85%;
        transition: opacity 0.4s;
        
      }

      .img-text{
        text-align: center;
        margin-top: 25%;
        color: #fff;
        
       
      }

      .sideone{
        
        width: 50%;
      }

      .sidetwo{
       
        width: 50%;
        text-align: right;
      }

      .name{
        font-size: 24px;
        font-weight: 500;
        line-height: 36px;
        letter-spacing: 0em;
        text-align: left;
        margin-top: 0;

      }

      .occupation{
        font-family: Poppins;
        font-size: 16px;
        font-weight: 500;
        line-height: 24px;
        letter-spacing: 0em;
        text-align: left;
        color: #FFA132;

      }

      .price{
        font-family: Poppins;
        font-size: 16px;
        font-weight: 500;
        line-height: 24px;
        letter-spacing: 0em;
      
        color: #A7A7A7;

      }

      #experience{
        font-family: Poppins;
        font-size: 16px;
        font-weight: 500;
        line-height: 24px;
        letter-spacing: 0em;
        margin-top:2.5%;
        color: #FFA132;
       
        
      
        
      }

      

      


      



      
    </style>

    
    <div class="cardstyle">

      
    <a class="learnmore" @click=${this.learnMore.bind(this)} >
    <img class="card-img" src="${App.apiBase}/images/${this.image}" alt="${this.name}"/>
    
    <div class="overlay" >
    
      <h1  class="img-text"> LEARN MORE</h1>
    
    </div>
    </a>
    

    <div class="card-txt">

    <div class="sideone">
        <h1 class="name">${this.name} </h1>
        <p class="occupation">${this.occupation}</p>
    </div>

    <div class="sidetwo"
        
        <p id="experience">${this.experience} years experience</p>
        <p class="price" >Rs${this.price}/day</p>
        
    </div>
        

    </div>






    </div>


    `
  }
  
})



